import styled from '@emotion/styled';

import { ICustomTheme } from 'interfaces';
// eslint-disable-next-line import/no-cycle
import { PhotoSizeType } from '../UsersPhoto';

export const StyledCircle = styled.div<{
  theme: ICustomTheme;
  size: PhotoSizeType;
  isHighlighted: boolean;
}>(({ theme, size, isHighlighted }) => ({
  alignItems: 'center',
  backgroundColor: isHighlighted
    ? theme.colors.paletteFromBO.secondary
    : theme.palette.grey[400],
  borderRadius: '100%',
  display: 'flex',
  height: 45,
  justifyContent: 'center',
  position: 'absolute',
  right: theme.spacing(size === 'small' ? -3 : -1),
  top: theme.spacing(3),
  transform: size === 'large' ? 'scale(2) translateY(20px)' : 'none',
  width: 45,
  zIndex: 1,
}));
